const basePath = "/api/subscriptions"

const SubscriptionEntity = (backClient) => ({
  current: async () => await backClient.get(`${basePath}/current`),
})

export default SubscriptionEntity
